import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import Button from "@material-ui/core/Button";

//Import
import { ThemeContext } from "../../../context/ThemeContext";
import {
  JuiceIcon,
  DollerIcon,
  UserIcon,
} from "../Lezato/Home/SvgIcons/SvgIcons";
import DonutChart from "../Lezato/Home/DonutChart";
import DailyTrending from "../Lezato/Home/DailyTrending";
import TrandingBlog from "../Lezato/Home/TrandingBlog";
import CustomerMap from "../Lezato/Home/CustomerMap";
import CustomersBlog from "../Lezato/Home/CustomersBlog";
import DeliveryMaps from "../Lezato/Home/DeliveryMaps";

import { Col, Badge, Card, Row } from "react-bootstrap";
import { CardTitle, CardBody } from "reactstrap";
import Chip from "@material-ui/core/Chip";
import img1 from "../../../images/card/1.png";
import img2 from "../../../images/card/2.png";
import img3 from "../../../images/card/44.png";
/// Bootstrap
// import { Row, Card, Col, Button, Nav, Container } from "react-bootstrap";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import { Form, FormGroup, Label, Input } from "reactstrap";
import Select from "react-select";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  InfoWindow,
  Marker,
} from "react-google-maps";
import Autocomplete from "react-google-autocomplete";
import Geocode from "react-geocode";
/* import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; */

//import TextField from '@mui/material/TextField';//
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";
/* import TextField from '@mui/material/TextField';
 */
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import {
  saveoutletDetails,
  updateletDetails,
  getoutletListMaster,
  GetOutletTimingList,
  saveOutletTiming,
  UpdateOutletTiming,
  SlotMasterList,
} from "../../../apiservicescall/api";

import { connect } from "react-redux";

import { AMINTOMNR, RESET } from "../../components/AppsMenu/MasterManagment/EcommerMnagement/adminToMnagerActions";


function TabContainer({ children }) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

const RevenuChart = loadable(() =>
  pMinDelay(import("../Lezato/Home/RevenuChart"), 1000)
);

const cardBlog = [
  // { title: 'Total Menus', Numbers: '459', Chartvalue: 60, Icons: <JuiceIcon /> },
  {
    title: "Total Revenue",
    Numbers: "87,561",
    Chartvalue: 80,
    Icons: <DollerIcon />,
  },
  { title: "Total Oders", Numbers: "247", Chartvalue: 60, Icons: <UserIcon /> },
  // { title: 'Total Customers', Numbers: '872', Chartvalue: 70, Icons: <UserIcon /> },
];

const Home = ({ props }) => {
  const [timings, setTimings] = useState([
    {
      dayname: "Monday",
      dayid: "1",
      time: [
        { starttime: "6.00AM", endtime: "11.00AM" },
        { starttime: "6.00AM", endtime: "11.00AM" },
        { starttime: "6.00AM", endtime: "11.00AM" },
      ],
    },
    {
      dayname: "Tuesday",
      dayid: "2",
      time: [
        { starttime: "6.00AM", endtime: "11.00AM" },
        { starttime: "6.00AM", endtime: "11.00AM" },
      ],
    },
    {
      dayname: "Wednesday",
      dayid: "3",
      time: [
        { starttime: "6.00AM", endtime: "11.00AM" },
        { starttime: "6.00AM", endtime: "11.00AM" },
      ],
    },
    {
      dayname: "Thursday",
      dayid: "4",
      time: [{ starttime: "6.00AM", endtime: "11.00AM" }],
    },
    {
      dayname: "Friday",
      dayid: "5",
      time: [{ starttime: "6.00AM", endtime: "11.00AM" }],
    },
    {
      dayname: "Saturday",
      dayid: "6",
      time: [{ starttime: "6.00AM", endtime: "11.00AM" }],
    },
    {
      dayname: "Sunday",
      dayid: "7",
      time: [],
    },
  ]);
  const values = "";
  var unixTimestamp = 1651822834;
  var date = new Date(unixTimestamp * 1000);
  const [startTime, handleDateChange] = useState(new Date());
  // useState(
  //   // date.toLocaleTimeString("it-IT")
  //   new Date()
  // );

  const [endTime, handleTimeChange] = useState(new Date());

  /* const [startTime, setStartTime] = useState(new Date(null));
  const [endTime, setEndTime] = useState(new Date(null)); */

  /* const [startTime, setStartTime] = useState(new Date(unixTimestamp * 1000));
  const [endTime, setEndTime] = useState(new Date(unixTimestamp * 1000)); */
  const [value, setValue] = useState([]);

  const [popUpPageShow, setPopUpPageShow] = useState();
  const [addNewUserModal, setAddNewUserModal] = useState();
  const [addtimemodal, setAddtimemodal] = useState();
  const [formIsValid, setFormIsValid] = useState(false);
  const [errors, setErrors] = useState({});
  const [isedit, setIsedit] = useState(false);
  const [isView, setIsview] = useState(false);
  const [Outlettimeobj, setOutlettimeobj] = useState({});

  const { changeBackground, background } = useContext(ThemeContext);
  const [largeModal, setLargeModal] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);

  const [isviewoutsid, setIsviewoutsid] = useState(
    JSON.parse(localStorage.getItem("userDetails")).username
  );

  const [timingslist, setTimingslist] = useState({
    outletCode: "",
    itemNo: "",
    dayName: "",
    dayId: "",
    dayStatus: "",
    slotId: "",
    startTime: "",
    endTime: "",
    slotName: "",
  });
  const [outlettiming, setOutlettiming] = useState({
    dayId: "",
    dayName: "",
    dayStatus: "",
    itemNo: "",
    outletCode: "",
    slottime: [
      {
        endTime: "",
        slotName: "",
        slotId: "",
        startTime: "",
      },
    ],
  });

  const [selectedOutlet, setSelectedOutlet] = useState(
    JSON.parse(localStorage.getItem("isviewoutsid"))
  );

  const [selectedoutletCode, setSelectedoutletCode] = useState(
    JSON.parse(localStorage.getItem("isviewoutsid"))
  );

  const [outletMasterlist, setOutletMasterlist] = useState([]);

  const [restaurantDetails, setRestaurantDetails] = useState({
    // RestaurantDetails
    restName: "",
    restMobileNumber: "",
    restEmailId: "",
    // restWebsiteUrl: "",
    reststateName: "",
    restcityName: "",
    restPincodeName: "",

    // Fssi
    restFssaiRegNumber: "",
    restFssaiFile: "",
    restFssaiRegisterstateName: "",

    // KycDetails
    restGstNumber: "",
    restPanNumber: "",
    restGstFile: "",
    restPanFile: "",
    restOutdoorPhoto: "",
    restIndoorPhoto: "",

    // BankDetails
    restBankAcNumber: "",
    restBankName: "",
    restIFSCNO: "",

    // OutletWorkingHours
    restTimeMonday: "",
    restTimeTuesday: "",
    restTimeWednesday: "",
    restTimeThursday: "",
    restTimeFriday: "",
    restTimeSaturday: "",
    restTimeSunday: "",

    stateMaster: [
      { label: "TN", value: "TN" },
      { label: "Kerala", value: "Kerala" },
      { label: "Puduchery", value: "Puduchery" },
      { label: "Karnataka", value: "Karnataka" },
    ],

    cityMaster: [
      { label: "Chennai", value: "Chennai" },
      { label: "Coimbatore", value: "Coimbatore" },
      { label: "Trichy", value: "Trichy" },
      { label: "Madurai", value: "Madurai" },
    ],

    areaMaster: [
      { label: "600192", value: "600192" },
      { label: "600142", value: "600192" },
      { label: "600194", value: "600192" },
      { label: "600195", value: "600192" },
    ],

    businessMaster: [
      { label: "HOTEL CUM RESTAURANT", value: "HOTEL CUM RESTAURANT" },
      {
        label: "RESTAURANT / ONLINE FOOD SELLING",
        value: "RESTAURANT / ONLINE FOOD SELLING",
      },
      {
        label: "HOME BASED CANTEEN",
        value: "HOME BASED CANTEEN OR TIFFIN SERVICE",
      },
      { label: "TIFFIN SERVICE Center", value: "TIFFIN SERVICE Center" },
      { label: "Uduppi", value: "Uduppi" },
      { label: "Takeaway", value: "Takeaway" },
      { label: "WHOLESALER OF FOOD ITEM", value: "WHOLESALER OF FOOD ITEM" },
      {
        label: "RETAILER OF SNACKS / TEA SHOPS",
        value: "RETAILER OF SNACKS / TEA SHOPS",
      },
      { label: "DHABA", value: "DHABA" },
      {
        label: "HAWKER (FOOD TRUCK OR HAWKER)",
        value: "HAWKER (FOOD TRUCK OR HAWKER)",
      },
    ],

    bankMaster: [
      { label: "Bank of Baroda", value: "Bank of Baroda" },
      { label: "Bank of India", value: "Bank of India" },
      { label: "Canara Bank", value: "Canara Bank" },
      { label: "Indian Bank", value: "Indian Bank" },
      { label: "Indian Overseas Bank", value: "Indian Overseas Bank" },
      { label: "Union Bank of India", value: "Union Bank of India" },
      { label: "State Bank of India", value: "State Bank of India" },
      { label: "Axis Bank", value: "Axis Bank" },
      { label: "City Union Bank", value: "City Union Bank" },
      { label: "HDFC Bank", value: "HDFC Bank" },
      { label: "ICICI Bank", value: "ICICIBank" },
      { label: "Other Bank", value: "OtherBank" },
    ],
    menu: [
      { label: "Breakfast", value: "Breakfast" },
      { label: "Lunch", value: "Lunch" },
      { label: "Dinner", value: "Dinner" },
    ],
  });
  const [day, setDay] = useState([
    { label: "Monday", value: "Monday,1" },
    { label: "Tuesday", value: "Tuesday,2" },
    { label: "Wednesday", value: "Wednesday,3" },
    { label: "Thursday", value: "Thursday,4" },
    { label: "Friday", value: "Friday,5" },
    { label: "Saturday", value: "Saturday,6" },
    { label: "Sunday", value: "Sunday,7" },
  ]);
  const [dayName, setDayName] = useState({
    label: "",
    value: "",
  });
  const [menu, setMenu] = useState([
    { label: "Breakfast", value: "Breakfast" },
    { label: "Lunch", value: "Lunch" },
    { label: "Dinner", value: "Dinner" },
  ]);
  const [slotFoodcty, setSlotFoodcty] = useState([]);
  const [dropdownslotmaster, setDropdownslotmaster] = useState([]);
  const [slotmaster, setSlotmaster] = useState([]);
  const [slottime, setSlottime] = useState([
    {
      endTime: "",
      slotName: "",
      slotId: "",
      startTime: "",
    },
  ]);

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );

  const [admintomanger, setAdmintomanger] = useState(
    JSON.parse(localStorage.getItem("admintomanger"))
  );

  const [userDetailsoutletResponses, setUserDetailsoutletResponses] = useState(
    JSON.parse(localStorage.getItem("userDetails")).outletResponses
  );
  const [selectedOutletfromcard, handleSelectedOutletfromcard] = useState({});


  useEffect(() => {
   
    if (admintomanger != null) {
      const admintomangerjson = admintomanger && admintomanger.split("-");
      let admintomangerOutletName = admintomangerjson[0].trim();
      let admintomangerOutletCode = admintomangerjson[1].trim();
      let admintomangerCompany = admintomangerjson[2].trim();
      getoutlettimeList(admintomangerOutletCode);
      changeBackground({ value: "light", label: "Light" });
      getoutletList(admintomangerCompany);
      getslotmaster(admintomangerOutletCode);
    } else {
      
      let outletCode = userDetails?.outletResponses[0]?.outletCode;
      let compCode = userDetails?.companyCode;
      getoutlettimeList(outletCode);
      changeBackground({ value: "light", label: "Light" });
      getoutletList(compCode);
      getslotmaster(outletCode);
    }
  }, [userDetails]);

  const getoutlettimeList = async (outletCode) => {
    let getoutletList = await GetOutletTimingList(outletCode);
    let getoutletListValue = getoutletList?.data?.data;
    setTimingslist(getoutletListValue);
  };

  const getslotmaster = async (outletCode) => {
    let getslotList = await SlotMasterList(outletCode);
    let getslotListValue = getslotList?.data?.data;
    await setSlotmaster(getslotListValue);

    let tempslotMasteroutmaster = getslotListValue.map(
      ({ slotName, slotId }) => ({
        label: slotName,
        value: slotId,
      })
    );

    await setDropdownslotmaster(tempslotMasteroutmaster);
  };

  const getoutletList = async (companyCode) => {
    let getoutletList = await getoutletListMaster(companyCode);
    let getoutletListValue = getoutletList?.data?.data;
    let outletCode = userDetails?.outletResponses[0]?.outletCode;
    let compCode = userDetails?.companyCode;

    if (admintomanger != null) {
      const admintomangerjson = admintomanger && admintomanger.split("-");
      let admintomangerOutletName = admintomangerjson[0].trim();
      let admintomangerOutletCode = admintomangerjson[1].trim();
      let admintomangerCompany = admintomangerjson[2].trim();
      let loggedinMnr = getoutletListValue && getoutletListValue.filter(items => items.outletCode == admintomangerOutletCode)
      setOutletMasterlist(loggedinMnr);
    } else {
      let loggedinMnr = getoutletListValue && getoutletListValue.filter(items => items.outletCode == outletCode)
      setOutletMasterlist(loggedinMnr);
    }

    if (userDetails?.firstLoginStatus == "Y") {
      window.location.replace('#/resetpassword');
      window.location.reload(true);
    }
  };

  const savetiming = async () => {
    

    // let multinames = Object.values(slotFoodcty).map((items) => {
    //   return items["slotId"] == items.value;
    // });
    let outmasterfiltered =
      slotFoodcty &&
      slotFoodcty.map(({ value, name }) => ({
        ["slotId"]: value,
      }));

    console.log("outlettiming", outlettiming);

    let startime24hourshr = new Date(startTime).getHours();
    let startime24hoursmi = new Date(startTime).getMinutes();
    let startTimefinalformat =
      startime24hourshr + ":" + startime24hoursmi + ":" + "00";
    let endtime24hourshr = new Date(startTime).getHours();
    let endime24hoursmi = new Date(startTime).getMinutes();
    let endTimefinalformat =
      endtime24hourshr + ":" + endime24hoursmi + ":" + "00";
    // const values = outlettiming?.dayName?.value.split(",");

    let valuescheck = "";

    console.log("outlettiming?.dayName.value", outlettiming?.dayName.value)

    if (outlettiming?.dayName.value != undefined) {
      valuescheck = outlettiming?.dayName.value.split(",");
    } else {
      valuescheck = outlettiming?.dayName.split(",");
    }

    let dayNameTrimmed = valuescheck[0].trim();
    let dayIdTrimmed = valuescheck[1].trim();

    let data;
    if (admintomanger != null) {
      const admintomangerjson = admintomanger && admintomanger.split("-");
      let admintomangerOutletName = admintomangerjson[0].trim();
      let admintomangerOutletCode = admintomangerjson[1].trim();
      let admintomangerCompany = admintomangerjson[2].trim();
      data = [
        {
          dayId: dayIdTrimmed || "",
          dayName: dayNameTrimmed || "",
          dayStatus: "true",
          outletCode: admintomangerOutletCode,
          slottime: outmasterfiltered,
        },
      ];
    } else {
      data = [
        {
          dayId: dayIdTrimmed || "",
          dayName: dayNameTrimmed || "",
          dayStatus: "true",
          outletCode: userDetails?.outletResponses[0]?.outletCode,
          slottime: outmasterfiltered,
        },
      ];
    }
    let reqforupload;
    if (isedit === false) {
      reqforupload = await saveOutletTiming(data);
      setAddtimemodal(false);
    } else {
      reqforupload = await UpdateOutletTiming(data);
      setAddNewUserModal(false);
    }
    if (reqforupload?.status === 200) {
      setOutlettiming({});
      setDayName({});
      setSlotFoodcty({});

      if (admintomanger != null) {
        const admintomangerjson = admintomanger && admintomanger.split("-");
        let admintomangerOutletName = admintomangerjson[0].trim();
        let admintomangerOutletCode = admintomangerjson[1].trim();
        let admintomangerCompany = admintomangerjson[2].trim();
        getoutlettimeList(admintomangerOutletCode);
      } else {
        getoutlettimeList(userDetails?.outletResponses[0]?.outletCode);
      }

      setPopUpPageShow(true);
      if (isedit === false) {
        swal("Success!", "Outlet Timing Created", "success");
      } else {
        swal("Success!", "Outlet Timing Updated", "success");
      }
    } else {
      swal("Oops", "Error, Please Try Later", "error");
      setIsview(false);
      setIsedit(false);
      setLargeModal(!largeModal);
    }
  };
  const onChangeCommonpopup = (key, value) => {
    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;

    if (key == "dayName") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["dayName"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        setDayName({
          ...value,
        });
        addFieldValue = { [key]: value };
        errorsLocal["dayName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "slotName") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["slotName"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        
        // let addFieldValuemaster = { ["slotId"]: value[0]?.value };
        console.log("addFieldValuemaster", typeof value);
        setSlotFoodcty([...value]);
        addFieldValue = { [key]: value };
        errorsLocal["slotName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }
    const newFormData = { ...outlettiming };
    newFormData[key] = value;
    setOutlettiming(newFormData);
  };

  const getCity = (addressArray) => {
    let city = "";
    for (let i = 0; i < addressArray.length; i++) {
      if (
        addressArray[i].types[0] &&
        "administrative_area_level_2" === addressArray[i].types[0]
      ) {
        city = addressArray[i].long_name;
        return city;
      }
    }
  };

  const getArea = (addressArray) => {
    let area = "";
    for (let i = 0; i < addressArray.length; i++) {
      if (addressArray[i].types[0]) {
        for (let j = 0; j < addressArray[i].types.length; j++) {
          if (
            "sublocality_level_1" === addressArray[i].types[j] ||
            "locality" === addressArray[i].types[j]
          ) {
            area = addressArray[i].long_name;
            return area;
          }
        }
      }
    }
  };

  const getState = (addressArray) => {
    let state = "";
    for (let i = 0; i < addressArray.length; i++) {
      for (let i = 0; i < addressArray.length; i++) {
        if (
          addressArray[i].types[0] &&
          "administrative_area_level_1" === addressArray[i].types[0]
        ) {
          state = addressArray[i].long_name;
          return state;
        }
      }
    }
  };

  const ClearIndicatorStyles = (base, state) => ({
    ...base,
    cursor: "pointer",
    color: state.isFocused ? "blue" : "black",
  });

  //multiselect//
  const CustomClearText = () => "clear all";
  const ClearIndicator = (props) => {
    const {
      children = <CustomClearText />,
      getStyles,
      innerProps: { ref, ...restInnerProps },
    } = props;
    return (
      <div
        {...restInnerProps}
        ref={ref}
        style={getStyles("clearIndicator", props)}
      >
        <div style={{ padding: "0px 5px" }}>{children}</div>
      </div>
    );
  };

  const handleChangetabl = (event, value) => {
    setActiveIndex(value);
  };

  const onEditUser = (data) => {
    setPopUpPageShow(true);
  };

  const onAddUpdateUserModalClose = () => {
    setPopUpPageShow(false);
  };

  const DateChange = async (items) => {
    
    console.log("items", items)
    console.log("itemsdayName", `${items.dayName}, ${items.dayId}`)
    const newFormData = { ...outlettiming };
    newFormData["dayName"] = `${items.dayName}, ${items.dayId}`;
    setOutlettiming(newFormData);

    // setOutlettiming({
    //   dayName: `${items.dayName, items.dayId}`,
    // });

    setDayName({
      label: items.dayName,
      value: items.dayId,
    });

    let selSlotTimes = items.slottime.map((stime) => {
      let selValue = {};
      selValue = dropdownslotmaster.filter(
        (mData) => mData.label == stime.slotName
      )[0];
      return selValue;
    });
    setSlotFoodcty(selSlotTimes);
    let selDay = {};
    if (items.dayName) {
      selDay = day.filter((d) => d.label == items.dayName)[0];
    }
    setDayName(selDay);
    setErrors({});
    setFormIsValid(true);
    setAddNewUserModal(true);
  };

  const addtiming = () => {
    setDayName({});
    setSlotFoodcty({});
    setAddtimemodal(true);
    setIsedit(false);
  };

  const onModalClose = () => {
    setAddtimemodal(!addtimemodal);
  };
  const onInfoWindowClose = (event) => { };

  const onMarkerDragEnd = (event) => {
    let newLat = event.latLng.lat(),
      newLng = event.latLng.lng();

    Geocode.fromLatLng(newLat, newLng).then(
      (response) => {
        const address = response.results[0].formatted_address,
          addressArray = response.results[0].address_components,
          city = getCity(addressArray),
          area = getArea(addressArray),
          state = getState(addressArray);
        this.setState({
          address: address ? address : "",
          area: area ? area : "",
          city: city ? city : "",
          state: state ? state : "",
          markerPosition: {
            lat: newLat,
            lng: newLng,
          },
          mapPosition: {
            lat: newLat,
            lng: newLng,
          },
        });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  const onTimingUser = () => {
    setPopUpPageShow(true);
  };

  const AsyncMap = withScriptjs(
    withGoogleMap((props) => (
      <GoogleMap
        google={props.google}
        defaultZoom={props.zoom}
      // defaultCenter={{ lat: this.state.mapPosition.lat, lng: this.state.mapPosition.lng }}
      >
        {/* InfoWindow on top of marker */}
        <InfoWindow
          onClose={onInfoWindowClose}
          position={{ lat: 13.018916, lng: 80.207064 }}
        >
          <div>
            <span style={{ padding: 0, margin: 0 }}>
              {/* {this.state.address} */}
            </span>
          </div>
        </InfoWindow>
        {/*Marker*/}
        <Marker
          google={props.google}
          name={"Dolores park"}
          draggable={true}
          onDragEnd={onMarkerDragEnd}
          position={{ lat: 13.018916, lng: 80.207064 }}
        />

        <Marker />
        {/* For Auto complete Search Box */}
        <Autocomplete
          style={{
            width: "100%",
            height: "40px",
            paddingLeft: "16px",
            marginTop: "2px",
            marginBottom: "500px",
          }}
        /* onPlaceSelected={this.onPlaceSelected}
  types={["(regions)"]} */
        />
      </GoogleMap>
    ))
  );

  return (
    <>
      <div className="mb-sm-4 d-flex flex-wrap align-items-center text-head">
        <h3 className="me-auto" style={{ fontFamily: "Roboto", color: "darkgreen" }}>
          {largeModal === true ? "My Outlets" : "Outlet Details"}
        </h3>

        {largeModal === false && (
          <button
            className="btn btn-primary btn-rounded me-3 mb-2"
            onClick={() => {
              setLargeModal(true);
            }}
          >
            {" "}
            Back{" "}
          </button>
        )}
      </div>

      {largeModal === true ? (
        <div
          className="row dash-cards"
          onClick={() => {
            setLargeModal(false);
          }}
        >
          {/* {userDetailsoutletResponses && userDetailsoutletResponses.map((items, key) => {
            return (
              <Col xl="4">
                <Card className="">
                  <Card.Header style={{ backgroundColor: "green" }}>
                    <Card.Title> {items?.outletName}</Card.Title>
                  </Card.Header>
                  <img
                    className="card-img-bottom img-fluid"
                    src={img3}
                    alt="Card cap"
                  />
                  <Card.Body>
                  </Card.Body>
                </Card>
              </Col>
            );
          })} */}


          <br />
          {outletMasterlist && outletMasterlist.map((items, key) => {
             
            // console.log("tMaslist.length", outletMasterlist)
            return <Col xl="4">
              <Card
                className=""
                onClick={() => {
                  handleSelectedOutletfromcard(items);
                }}
              >
                <Card.Header
                  style={{ backgroundColor: items?.activeStatus === "A" ? "green" : "red" }}>
                  <Card.Title> {items?.outletName} </Card.Title>
                </Card.Header>
                <img
                  className="card-img-bottom img-fluid"
                  src={img3}
                  alt="Card cap"
                />
                <Card.Body>
                  <Card.Text>
                    {items?.outletAddress} <br />
                    {items?.outletCity}  {items?.outletState} <br />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          })}
        </div>
      ) : (
        <>


          <div className="row outlet-info-cards">
            <Col xl="4">
              <Card className="text-white bg-secondary">
                <Card.Header>
                  <Card.Title className="text-white">My Info</Card.Title>
                </Card.Header>
                <Card.Body className="mb-0">
                  <Card.Text style={{ fontSize: "medium" }}>
                    {selectedOutletfromcard?.shortName}  <br />
                    {selectedOutletfromcard?.outletContactPerson} <br />
                    {selectedOutletfromcard?.outletEmailId}
                    <br />
                    {selectedOutletfromcard?.outletMobileNumber} <br />
                  </Card.Text>{" "}
                  <br /> <br />
                  <Card.Text style={{ fontSize: "medium" }}>
                    {selectedOutletfromcard?.outletAddress} <br />
                    {selectedOutletfromcard?.outletCity} <br />
                    {selectedOutletfromcard?.outletState} <br />
                  </Card.Text>
                </Card.Body>
                <Card.Footer className="bg-transparent border-0"></Card.Footer>
              </Card>
            </Col>

            <Col xl="4">
              <Card className="text-white bg-secondary">
                <Card.Header>
                  <Card.Title className="text-white">Kyc Details</Card.Title>
                </Card.Header>
                <Card.Body className=" mb-0">
                  <div className="row">
                    <div class="col-sm">
                      <Card.Text style={{ fontSize: "medium" }}>
                        GST NO:
                      </Card.Text>
                    </div>
                    <div class="col-sm">
                      <Badge as="a" variant="primary badge-lg">
                        {" "}
                        {selectedOutletfromcard?.outletGstNumber}
                      </Badge>
                    </div>
                  </div>{" "}
                  <br />
                  <div className="row">
                    <div class="col-sm">
                      <Card.Text style={{ fontSize: "medium" }}>
                        PAN NO:
                      </Card.Text>
                    </div>
                    <div class="col-sm">
                      <Badge as="a" variant="secondary badge-lg">
                        {" "}
                        {selectedOutletfromcard?.outletPanNumber}
                      </Badge>
                    </div>
                  </div>{" "}
                  <br />
                  <div className="row">
                    <div class="col-sm">
                      <Card.Text style={{ fontSize: "medium" }}>
                        FSSAI NO:
                      </Card.Text>
                    </div>
                    <div class="col-sm">
                      <Badge as="a" variant="danger badge-lg">
                        {" "}
                        {selectedOutletfromcard?.outletFssaiRegNumber}
                      </Badge>
                    </div>
                  </div>{" "}
                  <br />
                  <div className="row">
                    <div class="col-sm">
                      <Card.Text style={{ fontSize: "medium" }}>
                        Bank AC NO:
                      </Card.Text>
                    </div>
                    <div class="col-sm">
                      <Badge as="a" variant="warning badge-lg">
                        {" "}
                        {selectedOutletfromcard?.outletBankACNumber}
                      </Badge>
                    </div>{" "}
                    <br />
                  </div>
                </Card.Body>

              </Card>
            </Col>

            <Col xl="4">
              <Card className="text-white bg-secondary">
                <Card.Header>
                  <Card.Title className="text-white">
                    Timings
                    <span
                      style={{ paddingLeft: "190px" }}
                      className="icon-top-right"
                    >
                      <button
                        type="button"
                        className="rct-link-btn edit-btn"
                        onClick={() => onTimingUser()}
                      >
                        <i className="ti-pencil text-white"></i>
                      </button>
                    </span>
                  </Card.Title>
                </Card.Header>

                <Card.Body className=" mb-0">
                  {timingslist.map((slot) => {
                    // console.log("timingslist", slot);
                    return (
                      <div className="row">
                        <div class="col-sm-12">
                          <Card.Text style={{ fontSize: "medium" }}>
                            {slot.dayName}
                          </Card.Text>
                        </div>
                        {slot.slottime.map((time) => {
                          return (
                            <div class="col-sm-5 mt-1">
                              {/* <Tippy content={time.slotFoodcty}> */}
                              <Badge as="a" variant="success badge-lg" style={{ color: "black" }}>
                                {" "}
                                {time.startTime} - {time.endTime}
                              </Badge>
                              {/* </Tippy> */}
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </Card.Body>
              </Card>
            </Col>
          </div>

          <Modal
            isOpen={popUpPageShow}
            toggle={() => this.onAddUpdateUserModalClose()}
            /*  size={"lg"} */
            style={{ maxWidth: "1200px" }}
            backdrop="static"
          >
            <ModalHeader className="popup-header">
              Outlet Timings
              <span className="text-right popup-actions">
                <Button
                  style={{
                    backgroundColor: "yellowgreen",
                  }}
                  className="btn btn-secondary btn-rounded"
                  onClick={addtiming}
                /*  onClick={() => addtiming()} */
                >
                  Add Timing
                </Button>
                <Button>
                  <i
                    className="ti-close"
                    onClick={onAddUpdateUserModalClose}
                    style={{
                      paddingTop: "10px",
                      color: "black",
                      fontSize: "medium",
                    }}
                  ></i>
                </Button>
              </span>
            </ModalHeader>
            <ModalBody className="time-edit-con">
              <div className="row">
                {timingslist.map((items, index) => {
                  console.log("items", items);
                  return (
                    <Col xl="4">
                      <Card className="text-white  times-card">
                        <CardTitle className="text-white bg-secondary">
                          {items.dayName}
                          <span className="icon-top-right">
                            <button
                              type="button"
                              className="rct-link-btn edit-btn color-white text-white"
                              onClick={() => {
                                setIsedit(true);
                                DateChange(items);
                              }}
                            >
                              <i className="ti-pencil text-white"></i>
                            </button>
                          </span>
                        </CardTitle>
                        <CardBody>
                          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
          label="Start Time"
          value={value}
           onChange={handleChange} \
          renderInput={(params) => <TextField {...params} />}
        />
        <br/>
        <TimePicker
          label="End Time"
          value={value}
           onChange={handleChange} 
          renderInput={(params) => <TextField {...params} />}
        />
                          </LocalizationProvider> */}

                          {items?.slottime.map((data) => {
                            // 
                            console.log("data", data);
                            return (
                              <div>
                                <h4>
                                  {data.slotName} :
                                  <span className="badge badge-lg bg-green time-chip mr-2">
                                    {data.startTime} - {data.endTime}
                                    {/* <span className="icon-top-right">
                                    <button
                                      type="button"
                                      className="rct-link-btn edit-btn color-white text-white timing-edit"
                                      onClick={() => DateChange()}
                                      style={{
                                        paddingTop: "5px",
                                        paddingLeft: "8px",
                                      }}
                                    >
                                      <i className="ti-pencil text-white"></i>
                                    </button>
                                  </span> */}
                                  </span>
                                </h4>
                              </div>
                            );
                          })}
                        </CardBody>
                      </Card>
                    </Col>
                  );
                })}
              </div>

              {/* <div className="mb-sm-4 d-flex flex-wrap align-items-center text-head">
                <button
                  className="btn btn-primary btn-rounded me-3 mb-2"
                  onClick={onAddUpdateUserModalClose}
                >
                  {" "}
                  Cancel{" "}
                </button>
              </div> */}
            </ModalBody>
          </Modal>
          <Modal
            isOpen={addNewUserModal}
            toggle={() => this.onAddUpdateUserModalClose()}
            /* size={"lg"} */
            style={{ maxWidth: "800px" }}
            backdrop="static"
          >
            <ModalHeader>
              Update Time Slot
              <i
                className="ti-close"
                onClick={() => setAddNewUserModal(false)}
                style={{
                  paddingTop: "14px",
                  paddingLeft: "590px",
                  color: "black",
                  fontSize: "medium",
                }}
              ></i>
            </ModalHeader>

            <ModalBody>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <div className="row">
                  <div class="col-sm col-md-5 form-group">
                    <label as="a" variant="badge badge-rounded badge-danger">
                      {" "}
                      Day Name
                      <span class="text-warning">*</span>
                    </label>

                    <br />
                    <Select
                      options={day}
                      search
                      name="stateCode"
                      placeholder="Choose Dayname"
                      onChange={(event) => {
                        // 
                        onChangeCommonpopup("dayName", event);
                      }}
                      value={dayName}
                    />
                  </div>
                  <div class="col-sm col-md-5 form-group">
                    <label as="a" variant="badge badge-rounded badge-danger">
                      {" "}
                      Category
                      <span class="text-warning">*</span>
                    </label>

                    <br />
                    <Select
                      /* isDisabled={true} */
                      options={dropdownslotmaster}
                      defaultValue={slotFoodcty}
                      isMulti
                      closeMenuOnSelect={false}
                      styles={{
                        clearIndicator: ClearIndicatorStyles,
                      }}
                      components={{ ClearIndicator }}
                      search
                      name="category"
                      placeholder="Choose Category"
                      onChange={(event) =>
                        onChangeCommonpopup("slotName", event)
                      }
                    />
                  </div>
                  <br />

                  {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <div class="col-sm col-md-5 form-group">
                      <label as="a" variant="badge badge-rounded badge-danger">
                        {" "}
                        Start Time
                        <span class="text-warning">*</span>
                      </label>

                      <br />

                      <div style={{ width: "100px" }}>
                        <TimePicker
                          autoOk
                          placeholder="select starttime"
                          value={startTime}
                          onChange={handleDateChange}
                          onChange={(event) => {
                            
                            console.log("startTime", startTime);
                            handleDateChange(event, "date");
                          }}
                        />
                      </div>
                    </div>
                    <div class="col-sm col-md-5 form-group">
                      <label as="a" variant="badge badge-rounded badge-danger">
                        {" "}
                        End Time
                        <span class="text-warning">*</span>
                      </label>

                      <br />

                      <div style={{ width: "100px" }}>
                        <TimePicker
                          autoOk
                          placeholder="select endtime"
                          value={endTime}
                          onChange={(event) => {
                            console.log("endTime", endTime);
                            handleTimeChange(event, "date");
                          }}
                        />
                      </div>
                    </div>
                  </MuiPickersUtilsProvider> */}
                </div>
              </MuiPickersUtilsProvider>
            </ModalBody>
            <ModalFooter>
              <button
                className="btn btn-primary btn-rounded me-3 mb-3"
                onClick={() => {
                  savetiming();
                }}
              >
                {" "}
                Update{" "}
              </button>
            </ModalFooter>
          </Modal>
        </>
      )}
      <Modal
        isOpen={addtimemodal}
        toggle={() => this.onAddUpdateUserModalClose()}
        /* size={"lg"} */
        style={{ maxWidth: "600px" }}
        backdrop="static"
      >
        <ModalHeader>Add Timings</ModalHeader>
        <ModalBody>
          <div className="row">
            <div class="col-sm col-md-5 form-group">
              <label as="a" variant="badge badge-rounded badge-danger">
                {" "}
                Day Name
                <span class="text-warning">*</span>
              </label>

              <br />
              <Select
                options={day}
                value={dayName}
                search
                placeholder="Choose Day"
                onChange={(event) => onChangeCommonpopup("dayName", event)}

              />
            </div>
            <div class="col-sm col-md-5 form-group">
              <label as="a" variant="badge badge-rounded badge-danger">
                {" "}
                Category
                <span class="text-warning">*</span>
              </label>

              <br />
              <Select
                options={dropdownslotmaster}
                Value={slotFoodcty}
                isMulti
                closeMenuOnSelect={false}
                components={{ ClearIndicator }}
                styles={{
                  clearIndicator: ClearIndicatorStyles,
                }}
                /* isDisabled={true} */
                name="category"
                placeholder="Choose Category"
                onChange={(event) => onChangeCommonpopup("slotName", event)}
              />
            </div>
            <br />

            {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <div class="col-sm col-md-5 form-group">
                <label as="a" variant="badge badge-rounded badge-danger">
                  {" "}
                  Start Time
                  <span class="text-warning">*</span>
                </label>

                <br />

                <div style={{ width: "100px" }}>
                  <TimePicker
                    autoOk
                    placeholder="select starttime"
                    value={startTime}
                    onChange={(event) => {
                      console.log("startTime", startTime);
                      handleDateChange(event, "date");
                    }}
                  />
                </div>
              </div>
              <div class="col-sm col-md-5 form-group">
                <label as="a" variant="badge badge-rounded badge-danger">
                  {" "}
                  End Time
                  <span class="text-warning">*</span>
                </label>

                <br />

                <div style={{ width: "100px" }}>
                  <TimePicker
                    autoOk
                    placeholder="select endtime"
                    value={endTime}
                    onChange={(event) => {
                      console.log("endTime", endTime);
                      handleTimeChange(event, "date");
                    }}
                  />
                </div>
              </div>
            </MuiPickersUtilsProvider> */}
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-primary btn-rounded me-3 mb-3"
            onClick={() => {
              savetiming();
            }}
          >
            {" "}
            Save{" "}
          </button>

          <button
            className="btn btn-danger btn-rounded me-3 mb-3"
            onClick={() => onModalClose(false)}
          >
            {" "}
            Close{" "}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};
// export default Home;

const mapStateToProps = (state) => {
  // 
  // console.log("adminToMnager", state)
  return {
    outletName: state.adminToMnager.outletName,
    outletId: state.adminToMnager.outletId,
    companyCode: state.adminToMnager.companyCode
  }
};

// const mapDispatchToProps = (dispatch) => {
//   return {
//     AMINTOMNR: (outletName, outletId, companyCode) => {
//       dispatch(AMINTOMNR(outletName, outletId, companyCode))
//     },
//     RESET: () => {
//       dispatch(RESET())
//     }
//   }
// };

export default connect(mapStateToProps)(Home)